module.exports = __webpack_public_path__ + "static/media/start-buying-info2.622e2c7c.png";